import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "checked"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "search-item__product-title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("label", {
    class: "configurator-pick-a-card_option",
    onChange: _cache[0] || (_cache[0] = $event => ($setup.emit('card-picked'))),
    style: {"position":"relative"}
  }, [
    _createElementVNode("input", {
      type: "radio",
      name: "configurator-card",
      value: $props.card.id,
      checked: $props.isActive
    }, null, 8 /* PROPS */, _hoisted_1),
    _createElementVNode("img", {
      src: $props.card.featured_image,
      alt: $props.card.title
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("span", _hoisted_3, _toDisplayString($props.card.title), 1 /* TEXT */)
  ], 32 /* NEED_HYDRATION */))
}